import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://azkneyqjmzkuzsmwxxbu.supabase.co"; 
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF6a25leXFqbXprdXpzbXd4eGJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2MjEwMDQsImV4cCI6MjA3OTE5NzAwNH0.MOGBgSgyrmUUzKxSn4dhv8bpa4N24X7isMb4tKj1dns"; 

export const supabase = createClient(supabaseUrl, supabaseAnonKey);